import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import D1 from "../../components/ExcerciseTypes/Design/TypeIn";
import DesignUnderLine from "../../components/ExcerciseTypes/Design/DesignUnderLine";

const json = {
  1: { // Exercise num
    unit: "Unit 8",
    id: "SB3-U8-P59-E1",
    audio: "img/FriendsPlus/Page59/Audio/audio-e1-p59.mp3",
    video: "",
    component: DesignUnderLine,
    totalInput: 3,
    exerciseKey: "img/FriendsPlus/Page59/E1/Key/answerKey.png",
    questionImage: [
      [
        // Column2
        { url: 'img/FriendsPlus/Page59/E1/1.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page59/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page59/E1/3.jpg', audioUrl: 'img/FriendsPlus/Page59/Audio/tieude-e1-p59.mp3' },
        { url: 'img/FriendsPlus/Page59/E1/4.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page59/E1/5.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page59/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page59/E1/7.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page59/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page59/E1/9.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page59/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page59/E1/11.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page59/E1/12.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page59/E1/13.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page59/E1/14.jpg' },
        { url: 'img/FriendsPlus/Page59/E1/15.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page59/E1/16.jpg' },
        { url: 'img/FriendsPlus/Page59/E1/17.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page59/E1/18.jpg' },
        { url: 'img/FriendsPlus/Page59/E1/19.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page59/E1/20.jpg' },
      ],
    ],
  },
  2: { // Exercise num
    unit: 'Unit 8',
    id: 'SB3-U8-P59-E2',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: 'img/FriendsPlus/Page59/E2/1.jpg' }]],
  },
  3: { // Exercise num
    unit: 'Unit 8',
    id: 'SB3-U8-P59-E3',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page51/E4/Key/answerKey.png',
    isAllowSubmit: false,
    question: [],
    hideBtnFooter: true,
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page59/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page59/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page59/E3/3.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page59/E3/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page59/E3/5.jpg' },
        { url: 'img/FriendsPlus/Page59/E3/6.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page59/E3/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page59/E3/8.jpg' },
      ],
    ]
  },
  4: { // Exercise num
    unit: 'Unit 8',
    id: 'SB3-U8-P59-E4',
    audio: '',
    video: '',
    component: UI,
    // recorder: true,
    question: [],
    questionImage: [
      [{ url: 'img/FriendsPlus/Page59/E4/1.jpg' }],
      [{ url: 'img/FriendsPlus/Page59/E4/2.jpg' }],
    ],
  },
}

export default json;